import React from 'react';

const AnimationContext = React.createContext(null);

export { AnimationContext };

// Commit trace: 2025-09-27T02:31:50 - feat: introduce dynamic logic to AnimationContext.js

// Commit trace: 2025-11-20T15:37:49 - perf: improve memory usage in AnimationContext.js
